<div class="mainComponent">
  <ng-content></ng-content>
</div>
